import { useContext } from '@frontend/react';
import type { PaywallContextValue } from './PaywallContext';
import { PaywallContext } from './PaywallContext';

export const usePaywallContext = (): PaywallContextValue => {
  const context = useContext(PaywallContext);

  if (!context) {
    throw new Error('usePaywallContext must be used within a PaywallProvider');
  }

  return context;
};
